// @ts-nocheck
import React from 'react';

const ShkolaPage = () => {
  return (
    <>
      <section className="pt-2 pb-10">
        <div className="container md:px-[65px]">
          <div className="flex flex-col-reverse text-white md:flex-row">
            <div className="relative md:w-3/5 bg-[#A81414] md:h-[350px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
              <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-auto">Школа</h2>
              <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
                Школа є незамінним інструментом освіти, місцем зустрічі культури та віри. Вона є вирішальним місцем у формуванні особистості, оскільки передає концепцію світу, людини та історії. Шкільне середовище набуло значного розвитку в громаді у відповідь на потреби самої молоді, суспільства та Церкви.
              </div>
              <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
Салезіяни святого Івана Боско опікуються НВК “Школа-гімназія Шептицьких”, через яку можуть виховувати та формувати школярів та прививати їм життєву цінність бути добрим християнином та чесним громадянином.              </div>
            </div>
            <div className="relative md:w-2/5">
              <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[175px] md:border-b-[175px] md:border-l-[50px]
              border-t-transparent border-b-transparent border-l-red-600">
              </div>
              <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
              </div>
              <img
                className="md:h-[350px] object-cover object-left rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
                src="/images/shkola.png"
                alt=""
              />
            </div>
          </div>
          <div className="flex mt-8">
          <div className="relative w-[90%] md:w-2/5 bg-[#A81414] h-[80px] flex justify-start items-center pl-[24px] md:pl-8 rounded-tl-xl rounded-bl-xl">
            <h3 className="text-2xl text-justify text-white uppercase md:text-4xl nt-bold hyphens-auto">Салезіянська школа</h3>
          </div>
          <div className="relative md:w-3/5">
            <div class="absolute top-1/2 left-0 -translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[40px] border-b-[40px] border-l-[20px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
          </div>
        </div>
          <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
            <div className="md:w-1/3">
              <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
                НВК "ШКОЛА-ГІМНАЗІЯ ШЕПТИЦЬКИХ"
              </div>
              <div className="flex my-2 max-md:ml-4">
                <div className="hidden md:flex border-[2px] border-[#A81414] mr-6">
                </div>
                <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
                </div>
                <div>
                  <div className="pt-3">
                    Директор школи
                  </div>
                  <div className="pb-3">
                    Отець Тарас Байовський, СДБ
                  </div>
                  <div className="">
                    Вул. Гната Хоткевича, 16
                  </div>
                  <div className="">
                    Львів
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-1/3">
              
            </div>
            <div className="md:w-1/3">

            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default ShkolaPage;
